import React, { memo } from 'react'

import UserOutlined from '../../../assets/images/icons/UserOutlined.svg'
import Form from '../../formBuilder/form'
import { Accordian } from './accordian'

const AccordianComponent = memo(
  ({
    props,
    title,
    control,
    ocFields,
  }: {
    title: string
    ocFields: any[]
    control: any
    props: any
  }) => {
    return (
      <>
        <Accordian
          icon={<UserOutlined width={25} height={25} />}
          title={title}
          contentComponent={
            <Form
              control={control}
              ocFields={ocFields}
              subTitle=""
              title=""
              {...props}
            />
          }
        />
      </>
    )
  }
)

export default AccordianComponent
